import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "14", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12.01", y1: "6", y2: "6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Speaker";
const Speaker = memo(themed(Icon));
export {
  Speaker
};
//# sourceMappingURL=speaker.js.map
